
import { defineComponent } from 'vue';
import { Invite } from '@/data/models/Invite';
import useRequest from '@/composables/useRequest';
import { AcceptInviteRequest } from '@/data/requests/AcceptInviteRequest';
import { popModal } from 'jenesius-vue-modal';
import ButtonElement from '@/components/ButtonElement.vue';
import { useI18n } from 'vue-i18n';
import useEventStatus from '@/composables/useEventStatus';

export default defineComponent({
  props: {
    invite: {
      type: Object as () => Invite,
      required: true,
    },
    hasTeam: {
      type: Boolean,
      required: true,
    },
  },

  emits: ['refreshHomePage', 'changeError'],

  setup(props, ctx) {
    const { t } = useI18n();

    const { hasEnded } = useEventStatus();

    const { loading, execute } = useRequest<AcceptInviteRequest, never>(new AcceptInviteRequest(props.invite.id), t('errors.invite.accepting_invite'));

    const doAcceptInvite = () => {
      ctx.emit('changeError', undefined);

      execute()
        .then(() => {
          ctx.emit('refreshHomePage');
          popModal();
        })
        .catch(() => {
          ctx.emit('changeError', t('errors.invite.accepting_invite'));
        });
    };

    return {
      loading,
      doAcceptInvite,
      hasEnded,
    };
  },

  components: { ButtonElement },
});
